import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=c87cb192&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=js&"
export * from "./userInfo.vue?vue&type=script&lang=js&"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=c87cb192&prod&lang=scss&"
import style1 from "./userInfo.vue?vue&type=style&index=1&id=c87cb192&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87cb192",
  null
  
)

export default component.exports